export function listenForSearchParamsPolling(callback, interval = 50) {
  if (typeof callback !== "function") {
    console.error(
      "listenForSearchParamsPolling requires a function as a callback.",
    );
    return () => {};
  }

  let lastSearch = window.location.search;
  let intervalId = null;

  const checkSearchParamsChange = () => {
    const currentSearch = window.location.search;
    if (currentSearch !== lastSearch) {
      // console.log(`[Polling] Search params changed: "${lastSearch}" -> "${currentSearch}"`); // Optional log
      const searchParams = new URLSearchParams(currentSearch);
      callback(searchParams, currentSearch);
      lastSearch = currentSearch;
    }
  };

  // Start polling at a regular interval
  intervalId = setInterval(checkSearchParamsChange, interval);

  console.log(
    `Started polling for search parameter changes every ${interval}ms.`,
  );

  // Function to stop polling
  return () => {
    if (intervalId !== null) {
      clearInterval(intervalId);
      intervalId = null;
      console.log("Stopped polling for search parameter changes.");
    }
  };
}

// --- How to Use Polling (Not generally recommended) ---
// const stopPolling = listenForSearchParamsPolling((newParams, newQueryString) => {
//     console.log('[Polling] Search params were added or changed!');
//     console.log('[Polling] New URLSearchParams object:', newParams);
// });

// stopPolling(); // Call this when you want to stop
